export const textareaFieldStyles = ['secondary', 'tertiary'] as const
export type TextareaFieldStyle = (typeof textareaFieldStyles)[number]

export type TextareaFieldArgs = {
  variant?: TextareaFieldStyle
  label: string
  hint?: string
  placeholder?: string
  value?: string
  name?: string
  id?: string
  disabled?: boolean
  required?: boolean
  rows?: number
  maxlength?: number
  resize?: 'none' | 'vertical' | 'both'
  validation?: { status: 'error' | 'success' }
}
